var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"title-row"},[_c('span',{staticClass:"title"},[_vm._v(_vm._s(_vm.title))]),(_vm.hint)?_c('span',{staticClass:"hint"},[_vm._v(_vm._s(_vm.hint))]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }